import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CmaReportLink.css';

// A turn that generated a CMA report: structured_data of type "cma_report" on
// either a live /ria/chat response (ria_service._extract_structured_data) or
// a message reloaded from conversation history (rebuilt from the stored
// get_cma_report tool result by firestore_service._note_structured_data).
// Raw get_cma_report tool_results are also accepted, mirroring
// RiaNoteLinks.extractRiaNoteLinks, in case a caller passes them directly.
export const extractCmaReportLink = (source) => {
  if (!source) return null;
  try {
    const sd = source.structured_data;
    if (sd?.type === 'cma_report' && sd.action_buttons?.[0]?.target) {
      return { target: sd.action_buttons[0].target, address: sd.address || sd.data?.address };
    }
    if (Array.isArray(source.tool_results)) {
      const tr = source.tool_results.find((r) => r?.name === 'get_cma_report' && !r.error && r.result?.reportId);
      if (tr) {
        return { target: `/cma/${tr.result.reportId}`, address: tr.result.address };
      }
    }
  } catch (err) {
    console.warn('[Ria] Failed to parse CMA report link:', err);
  }
  return null;
};

const ReportIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" />
  </svg>
);

/**
 * Clickable link under a Ria reply that generated a CMA report — opens the
 * in-app report view at the structured_data's action_buttons target.
 */
export default function CmaReportLink({ link, className = '' }) {
  const navigate = useNavigate();
  if (!link?.target) return null;

  return (
    <div className={`crl-ria-cma-link ${className}`.trim()}>
      <button
        type="button"
        className="crl-ria-cma-link-btn"
        onClick={(e) => { e.stopPropagation(); navigate(link.target); }}
        title="Open"
      >
        <ReportIcon /> View CMA Report{link.address ? ` — ${link.address}` : ''}
      </button>
    </div>
  );
}
